/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Ai_AnalysisInputs */

const en_jobs_ai_analysis = /** @type {(inputs: Jobs_Ai_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis`)
};

const de_jobs_ai_analysis = /** @type {(inputs: Jobs_Ai_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Analyse`)
};

const fr_jobs_ai_analysis = /** @type {(inputs: Jobs_Ai_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse IA`)
};

const es_jobs_ai_analysis = /** @type {(inputs: Jobs_Ai_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis IA`)
};

const it_jobs_ai_analysis = /** @type {(inputs: Jobs_Ai_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi AI`)
};

const nl_jobs_ai_analysis = /** @type {(inputs: Jobs_Ai_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-analyse`)
};

const pl_jobs_ai_analysis = /** @type {(inputs: Jobs_Ai_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza AI`)
};

const fi_jobs_ai_analysis = /** @type {(inputs: Jobs_Ai_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoälyanalyysi`)
};

const da_jobs_ai_analysis = /** @type {(inputs: Jobs_Ai_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-analyse`)
};

const sv_jobs_ai_analysis = /** @type {(inputs: Jobs_Ai_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-analys`)
};

/**
* | output |
* | --- |
* | "AI Analysis" |
*
* @param {Jobs_Ai_AnalysisInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_ai_analysis = /** @type {((inputs?: Jobs_Ai_AnalysisInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Ai_AnalysisInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_ai_analysis(inputs)
	if (locale === "fr") return fr_jobs_ai_analysis(inputs)
	if (locale === "es") return es_jobs_ai_analysis(inputs)
	if (locale === "it") return it_jobs_ai_analysis(inputs)
	if (locale === "nl") return nl_jobs_ai_analysis(inputs)
	if (locale === "pl") return pl_jobs_ai_analysis(inputs)
	if (locale === "fi") return fi_jobs_ai_analysis(inputs)
	if (locale === "da") return da_jobs_ai_analysis(inputs)
	if (locale === "sv") return sv_jobs_ai_analysis(inputs)
	return en_jobs_ai_analysis(inputs)
});